import { render, staticRenderFns } from "./ProductsFetch.vue?vue&type=template&id=afc451b4&"
import script from "./ProductsFetch.vue?vue&type=script&lang=js&"
export * from "./ProductsFetch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppSliceLoader: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppSliceLoader.vue').default,AppContainer: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppContainer.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default})
